import React, { useContext, useMemo } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSitemap } from '@fortawesome/free-solid-svg-icons'
import UserContext from 'context/user-context'
import { splitColumnDescription } from './split-column'

// Shown at the top of a report that has been split. It is the counterpart to ChildReportBanner:
// that one says "you can't edit this", this one says "what you edit here lands in all of these".
//
// The children themselves live in the split modal, which is also where more get added — seeing
// which slices exist and deciding to add another are one task, not two.
//
// Only rendered once the report has children; before that it is an ordinary report.
const ParentReportBanner = ({ report, onManage, canEdit }) => {
  const user = useContext(UserContext)
  const count = report?.child_reports_count || 0

  const description = useMemo(
    () => splitColumnDescription(report, user?.municipality?.setting),
    [report, user]
  )

  if (!count) return null

  const noun = `child report${count === 1 ? '' : 's'}`

  return (
    <Alert variant="info" className="d-flex align-items-center gap-3 py-2">
      <FontAwesomeIcon icon={faSitemap} className="text-info" />
      <div className="flex-grow-1">
        <strong>Template report.</strong>{' '}
        {count} {noun} split off of {description} — edits here appear in{' '}
        {count === 1 ? 'it' : 'all of them'} automatically.
      </div>
      <Button variant="light" size="sm" className="text-primary border" onClick={onManage}>
        {canEdit ? 'Manage' : 'View'} {noun}
      </Button>
    </Alert>
  )
}

export default ParentReportBanner
